import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginStatus: false,
};

const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    alterUserInfo(state, action) {
      state.loginStatus = action.payload.loginStatus;
    },
  },
});

export const { alterUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
